import { FilterMatchMode } from "primereact/api";

export class FuncionalidadMenu {
    model = {
        id: {
            value: null,
            export: false
        },
        idp: {
            value: null,
            export: false
        },
        nombre: {
            value: '',
            header: 'Nombre',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            filterField: 'nombre',
            table: true,
            filter: true,
            sort: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        codigo: {
            value: '',
            header: 'Código',
            required: 'Campo requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 100,
            min: 4,
        },
        permiso: {
            header: 'Permiso',
            value: null,
            optionLabel: 'nombre',
            export: false
        },
        estado: {
            header: 'Estado',
            value: { nombre: 'Activo', cat_id: true },
            required: 'Estado es requerido',
            optionLabel: 'nombre',
            export: true,
            table: true
        },
    }
    optionLabel = 'nombre'
}
